// Libraries
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { defineMultiStyleConfig } = createMultiStyleConfigHelpers(['tbody', 'table', 'thead', 'tfoot']);

const base = {
  table: {
    borderRadius: 'xl',
    borderCollapse: 'collapse',
    tableLayout: 'fixed',
  },
  thead: {
    borderBottom: 'light',
    tr: {
      bg: 'table.footer',
      th: {
        _first: {
          borderTopLeftRadius: 'xl',
        },
        _last: {
          borderTopRightRadius: 'xl',
        },
      },
    },
    borderRadius: 'xl',
  },
  tbody: {
    tr: {
      td: {
        overflow: 'hidden',
        _first: {
          borderBottomLeftRadius: 'xl',
        },
        _last: {
          borderBottomRightRadius: 'xl',
        },
      },
    },
    borderRadius: 'xl',
  },
};
/**
 * Table style configuration for the tables component.
 */
export const Table = defineMultiStyleConfig({
  variants: {
    cardTable: {
      ...base,
    },
    cardLightTable: {
      ...base,
      thead: {
        borderBottom: 'section',
        tr: {
          bg: 'transparent',
          th: {
            borderRadius: '0',
          },
        },
      },
      tbody: {
        tr: {
          td: {
            padding: 0,
          },
        },
      },
      tfoot: {
        borderTop: 'section',
      },
    },
  },
});
